<div class="task-container">
  <div class="page-header">
    <span class="page-title">Tarefas</span>
  </div>
  <span class="h2" style="font-weight: bold">Filtros</span>
  <div class="filters">
    <mat-form-field subscriptSizing="dynamic" [matTooltip]="'Pesquise por nome, descrição, identificador, título, responsável ou relacionamento'">
      <mat-label>Pesquisar</mat-label>
      <input id="task-search" [mentions]="[]" matInput (keyup)="search($event)" placeholder="Ex. Mia" #input>
    </mat-form-field>
    <app-person-picker [selectedPeople]="selectedPeople" [people]="usersToShowBadges" (onSelectionChange)="personSelected($event)"></app-person-picker>
    <app-deadline-filter (onChange)="deadlineChange($event)"
                         (onDateChange)="deadlineDateChange($event)"></app-deadline-filter>
    <app-select-filter
      [control]="statusFilter"
      [options]="statusOptions"
    />
    <app-button-w-loader
      type="yellow"
      label="+ Nova tarefa"
      (buttonClick)="newTask()"
    />
  </div>

  <div class="item-counter-list">
    @for (status of statusMap.keys(); track status) {
      <app-item-counter
        [title]="statusMap.get(status)?.name ?? ''"
        [value]="statusMap.get(status)?.count ?? 0"
        [titleColor]="statusMap.get(status)?.color ?? ''"
        [cardColor]="null"
        [textColor]="(statusMap.get(status)?.invertTitleColor ?? false) ? 'white' : 'black'"
      ></app-item-counter>
      @if (statusMap.get(status)?.showSeparator) {
        <div class="counter-separator"></div>
      }
    }
  </div>
  <app-task-table
    [values]="taskService.taskList()"
    [toBeDeleted]="toBeDeleted"
    [totalItems]="taskService.taskPagination()?.total ?? 0"
    [pageSize]="pageSize()"
    (pageChange)="onPageChange($event)"
    (openDetails)="openDetails($event)"
    (sortChange)="onSortChange($event)">
  </app-task-table>
</div>
